// extracted by mini-css-extract-plugin
export default {"logoContainerBlk":"Logo_logoContainerBlk__9mUK9"};